import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Typography } from '@mui/material';
import { Goods } from 'components/Goods';

export const GoodsPage: FC = () => {
	return (
		<Page title="Goods – MPM Service">
			<Goods />
		</Page>
	);
};
